import baseScmService from 'services/baseScmService';

const superBatchAcademyTopicService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    createSuperBatchAcademyTopic: build.mutation({
      query: ({ sbatGroupId, superBatchId }) => ({
        method: 'POST',
        url: '/super-batch-academy-topics',
        body: {
          super_batch_academy_topic: {
            super_batch_id: superBatchId,
            sbat_group_id: sbatGroupId,
          },
        },
      }),
      invalidatesTags: (result, error, { sbatGroupId }) => {
        return error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }];
      },
    }),
    deleteSuperBatchAcademyTopic: build.mutation({
      query: ({ sbatGroupId, superBatchAcademyTopicId }) => ({
        method: 'DELETE',
        url: `/super-batch-academy-topics/${superBatchAcademyTopicId}`,
      }),
      invalidatesTags: (result, error, { sbatGroupId }) => {
        return error ? [] : [{ type: 'SbatGroup', id: sbatGroupId }];
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useCreateSuperBatchAcademyTopicMutation,
  useDeleteSuperBatchAcademyTopicMutation,
} = superBatchAcademyTopicService;

export default superBatchAcademyTopicService;
